import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import { Mail, Phone, User } from "lucide-react"; // Assuming you're using lucide icons
import FullScreenLoader from "../components/FullScreenLoader";


function Faqs() {
    const navigate = useNavigate();
    const [showFormPopup, setShowFormPopup] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);


    const handleReachOut = (context) => {
        setShowFormPopup(true);
        setFormSubmitted(false); // Reset form submission when opening popup
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        // You can add form validation or API call here
        setFormSubmitted(true);
    };

    // Form PHP
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        // Optional: basic validation
        if (!formData.fullName || !formData.email || !formData.phone || !formData.message) {
            setResponseMessage("Please fill in all fields.");
            setLoading(false);
            return;
        }

        const formBody = new URLSearchParams(formData).toString();

        try {
            const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/contact-form-premier-pumps.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formBody,
            });

            const result = await response.json();

            if (result.status === "success") {
                setResponseMessage("Message sent successfully! ✅");
                setFormData({
                    fullName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
                setShowFormPopup(false); // close form
                // setShowThankYouPopup(true); // open thank-you popup
                navigate("/thank-you?formId=faqs");
            } else {
                setResponseMessage("Error: " + result.message);
            }
        } catch (error) {
            setResponseMessage("Error sending message. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    // Form PHP
    // FAQ's
    const faqs = [
        {
            question: "What kind of quality and compliance documentation come along with PREMIER’s products?",
            answer: `
                Upon request, for every one of its products, PREMIER can provide:
                <ul>
                    <li>Manufacturer and third-party lab material grade test certificate</li>
                    <li>Third-party lab test certificate for shaft ultrasonic defect detection</li>
                    <li>Dynamic balancing test certificate for rotor shaft assemblies</li>
                    <li>Pressure test certificate</li>
                    <li>Pump performance test certificate</li>
                    <li>Certificate of Origin and free trade agreement compliance documentation for export sales</li>
                </ul>
            `,
        },
        {
            question: "Can PREMIER supply pumps and spares that are interchangeable with other Liquid Ring Vacuum Pump manufacturers?",
            answer:
                "Yes, PREMIER can custom manufacture pumps and spares that are 100% interchangeable with most other Liquid Ring Vacuum Pump manufacturers. Contact PREMIER to know more about this.",
        },
        {
            question: "What is PREMIER’s delivery time on Liquid Ring Vacuum Pumps and spares?",
            answer:
                "Depending on the material of construction, PREMIER can supply Liquid Ring Vacuum Pumps and spares with delivery times ranging from ready stock to 6 weeks.",
        },
        {
            question: "Can PREMIER provide support for installation and operation of their Liquid Ring Vacuum Pumps?",
            answer:
                "Every PREMIER Liquid Ring Vacuum Pump comes with an exhaustive and highly illustrated installation and operation manual. Our technical experts are always available to answer our customer's questions.",
        },
        {
            question: "How do I select the right Liquid Ring Vacuum Pump for my application?",
            answer:
                "Contact PREMIER for a detailed system analysis to understand what size of Liquid Ring Vacuum Pump suits your process.",
        },
        {
            question: "Can Liquid Ring Vacuum Pumps handle corrosive gases?",
            answer:
                "Yes, PREMIER can supply Liquid Ring Vacuum Pumps and spares in corrosion resistant materials such as Stainless Steel 304 and 316. Ask PREMIER for cost effective stainless steel cladding options for corrosive applications.",
        },
        {
            question: "Can PREMIER offer customized Vacuum systems solutions?",
            answer:
                "Yes, PREMIER can provide custom engineered Vacuum systems that include material selection, Liquid Ring Vacuum Pump selection and common skid package with instrumentation.",
        },
        {
            question: "How can I request technical support and a Liquid Ring Vacuum Pump or spare quote?",
            answer:
                "Contact our sales team at <a href='mailto:support@premierpumps.com'>support@premierpumps.com</a>",
        },
        {
            question: "What is the typical service life of a Liquid Ring Vacuum Pump?",
            answer:
                "Optimized material selection for building PREMIER’s pumps to suit your process along with regular preventive maintenance can make PREMIER Liquid Ring Vacuum Pump last for several years.",
        },
        {
            question: "Can PREMIER repair and recondition my old Liquid Ring Vacuum Pump?",
            answer:
                "Yes, contact PREMIER at <a href='mailto:support@premierpumps.com'>support@premierpumps.com</a> to bring your old and decommissioned Liquid Ring Vacuum Pump back into service.",
        },
    ];
    const itemRefs = useRef([]);
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        const isOpen = openIndex === index;
        setOpenIndex(isOpen ? null : index);

        if (!isOpen) {
            // Scroll only if the item is not fully visible
            setTimeout(() => {
                const el = itemRefs.current[index];
                if (el) {
                    const rect = el.getBoundingClientRect();
                    const isOutOfView = rect.bottom > window.innerHeight;

                    if (isOutOfView) {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            }, 100); // Timeout ensures DOM has rendered the expanded content
        }
    };

    // FAQ's
    return (
        <div>
            {loading && <FullScreenLoader label="Sending..." />}
            {/* Popup */}
            {showFormPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <div className="popup-header d-flex justify-content-center align-items-center">
                            <h5 className=''>{formSubmitted ? "Thank You!" : "Reach out to us!"}</h5>
                            <button
                                className="btn-close fs-4"
                                onClick={() => setShowFormPopup(false)}
                            >
                                ×
                            </button>
                        </div>

                        <div className="form-container">
                            {!formSubmitted ? (
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group flex-column">

                                        {/* Full Name */}
                                        <label className="fw-medium">
                                            Full Name <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <User size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="fullName"
                                                    name="fullName"
                                                    type="text"
                                                    placeholder="Enter your full name"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    required
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <label className="fw-medium">
                                            Email <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <Mail size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    required
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        {/* Phone */}
                                        <label className="fw-medium">Phone</label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <div className="d-flex align-items-center">
                                                <Phone size={20} className="input-icon text-blue me-2" />
                                                <input
                                                    id="phone"
                                                    name="phone"
                                                    type="tel"
                                                    placeholder="Enter your phone number"
                                                    className="form-control border-start rounded-0 ps-2"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = [
                                                            "Backspace", "ArrowLeft", "ArrowRight", "Delete",
                                                            "Tab", "Home", "End", "+", "-", "(", ")", " "
                                                        ];
                                                        const isNumber = /^[0-9]$/.test(e.key);
                                                        const isAllowed = allowedKeys.includes(e.key);
                                                        if (!isNumber && !isAllowed) e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Message */}
                                        <label className="fw-medium mt-3">Message</label>
                                        <div className="input-wrapper rounded-20 my-1 p-2">
                                            <textarea
                                                id="message"
                                                name="message"
                                                placeholder="Your Message"
                                                rows="4"
                                                className="form-control rounded-0 ps-2"
                                                required
                                                value={formData.message}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Submit */}
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary rounded-20 my-1 px-4 py-3">
                                                {loading ? "Sending..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>

                                    {responseMessage && <p className="text-center mt-3">{responseMessage}</p>}
                                </form>
                            ) : (
                                <div className="text-center p-4">
                                    <p>Thank you for reaching out! We'll get back to you soon.</p>
                                    <button className="btn btn-primary mt-3 px-4" onClick={() => {
                                        setShowFormPopup(false);
                                    }}>
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>


                    </div>
                </div>
            )}

            {/* Popup */}

            {/* thank you popup  */}

            {showThankYouPopup && (
                <div className="thankyou-popup-overlay d-flex align-items-center justify-content-center" id="thankyou-popup-overlay">
                    <div className="thankyou-popup-box position-relative" id="thankyou-popup-box">
                        <div className="thankyou-popup-body text-center d-flex align-items-center justify-content-center flex-column">
                            <h5 className="mb-3 fs-2">🎉 Thank You!</h5>
                            <p>We’ve received your message and will get back to you shortly.</p>
                            <button
                                className="btn btn-primary mt-3 px-4"
                                onClick={() => setShowThankYouPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* thank you popup  */}
            {/* FAQ's */}
            <section className="container py-5">
                {/* Heading */}
                <div className="text-center mb-4">
                    <h2 className="fw-bold text-dark display-5">Frequently Asked Questions</h2>
                    {/* <p className="text-muted">We have put together some commonly asked questions</p> */}
                </div>

                {/* FAQ List */}
                <div className='row justify-content-center'>
                    <div className='col-lg-8'>
                        <div className="accordion" id="faqAccordion">
                            {faqs.map((faq, index) => (
                                <div
                                    className="accordion-item border-bottom border-0 mb-3 rounded"
                                    key={index}
                                    ref={(el) => (itemRefs.current[index] = el)}
                                >
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button d-flex align-items-center bg-white text-dark fw-bold ${openIndex === index ? "" : "collapsed"}`}
                                            type="button"
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            {faq.question}
                                            <FaChevronDown
                                                className={`ms-auto transition-transform ${openIndex === index ? "rotate-icon" : ""}`}
                                                style={{ transition: 'transform 0.3s ease' }}
                                            />
                                        </button>
                                    </h2>
                                    <div
                                        className={`accordion-collapse collapse ${openIndex === index ? "show" : ""}`}
                                        data-bs-parent="#faqAccordion"
                                    >
                                        <div
                                            className="accordion-body custom-scroll"
                                            dangerouslySetInnerHTML={{ __html: faq.answer }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


                {/* Contact Us Section */}
                <div className="text-center mt-4">
                    <div className='row justify-content-center'>
                        <div className='col-lg-5'>
                            <p className=" bg-light p-2 rounded-pill border">
                                Didn’t find what you’re looking for?{" "}
                                <button onClick={() => handleReachOut("services")} className='border-0 text-danger fw-semibold text-decoration-underline' >Contact Us</button>
                            </p>
                        </div>
                    </div>

                </div>
            </section>
            {/* FAQ's */}
        </div>
    )
}

export default Faqs
